import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-notes-summary',
    templateUrl: './notes-summary.component.html',
    styleUrls: ['./notes-summary.component.scss'],
    standalone: false
})
export class NotesSummaryComponent {
  @Input() data: any;
}
